<template>
  <div class="not-found">
    <div class="not-found-content">
      <!-- <img src="@/assets/404.png" alt="404" class="not-found-image"> -->
      <h1 class="not-found-title">404</h1>
      <p class="not-found-text">抱歉，您暂无该页面访问权限，请联系管理员开通</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  methods: {
    goHome() {
      this.$router.push('/home');
    }
  }
}
</script>

<style lang="less" scoped>
.not-found {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f7fa;

  &-content {
    text-align: center;
    padding: 20px;
  }

  &-image {
    width: 300px;
    height: 300px;
    margin-bottom: 20px;
  }

  &-title {
    font-size: 72px;
    color: #409EFF;
    margin: 0;
    line-height: 1.2;
  }

  &-text {
    font-size: 20px;
    color: #606266;
    margin: 20px 0;
  }
}
</style> 